import { MasqueradeUserType } from './types';

export const USER = 'userToken' as const;
export const SELLER = 'sellerToken' as const; // <VERTICAL PREFIX>_<id>_<hash>
export const MASQUERADE_BUYER: MasqueradeUserType = 'masqueradeBuyer'; // U_<id>
export const MASQUERADE_BUYER_USER_TOKEN = 'masqueradeBuyerUserToken' as const;
export const MASQUERADE_SELLER: MasqueradeUserType = 'masqueradeSeller'; // S_<id>_<VERTICAL PREFIX>
export const USER_TYPE = 'userType' as const;
export const REAL_USER_TYPE = 'realUserType' as const;
export const USER_EMAIL = 'userEmail' as const;
export const USER_EMAIL_TOKEN = 'userEmailToken' as const;
export const USER_LEGACY = 'userreg' as const;
export const GUEST_ID = 'guestId' as const;
export const EVER_LOGGED_IN = 'eli' as const;
export const PASSWORD_RESET = 'passwordToken' as const;
export const AB_TEST_ELIGIBILITY = 'abe' as const;
export const HOMEPAGE_USER_GROUP = 'hpUserGroup' as const;
export const DIRECT_LOGIN_ORIGINAL_USER = 'directLoginOriginalUser' as const;

export const COOKIE_KEYS = {
    USER,
    SELLER,
    MASQUERADE_BUYER,
    MASQUERADE_BUYER_USER_TOKEN,
    MASQUERADE_SELLER,
    USER_TYPE,
    REAL_USER_TYPE,
    USER_EMAIL,
    USER_EMAIL_TOKEN,
    USER_LEGACY,
    GUEST_ID,
    EVER_LOGGED_IN,
    PASSWORD_RESET,
    AB_TEST_ELIGIBILITY,
    HOMEPAGE_USER_GROUP,
    DIRECT_LOGIN_ORIGINAL_USER,
};
